export default class PlatformAccess {
  constructor() {
    this.Dashboard = null;
    this.ManageAccess = null;
    this.Clients = null;
  }
}
